import { render, staticRenderFns } from "./incl-download.vue?vue&type=template&id=0719d984&scoped=true"
import script from "./incl-download.vue?vue&type=script&lang=js"
export * from "./incl-download.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0719d984",
  null
  
)

export default component.exports